import React from 'react'
import { Link } from 'react-router-dom'
import { t } from 'ttag'

const UpgradeOptions = ({ selectedItem }) => {
  const basicAccount = () => {
    return (
      <div>
        <div className="col-xs-2"></div>
        <div className="col-xs-8">
          <div className="h2account h2account-basic">
            <div className="graphic-top"></div>
            <div className="content">
              <h3 className="text-center section-heading">Headed2 Account</h3>
              <hr />
              <h4 className="text-center">{t`Price: Free`}</h4>
              <div className="description">
                {t`Ideal for students and jobseekers who want to save the work they do
                                in the system, including self-assessments, viewed occupations, budgets, and resumes.`}
              </div>
              <Link
                to="/register"
                className="btn btn-success btn-full"
                style={{ marginBottom: '15px' }}>
                <span>{t`Create Account`}</span>
              </Link>
              <h4>{t`Saving your work and explore in Headed2:`}</h4>
              <ul className="free-account-list">
                <li className="free-save">{t`Save your work`}</li>
                <li className="free-assessment">{t`Take self-assessments`}</li>
                <li className="free-occupations">{t`View occupations`}</li>
                <li className="free-budgets">{t`Build budgets`}</li>
                <li className="free-resumes">{t`Create Resumes`}</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xs-2">
          <Link to="/educators/upgrades/free">
            <img
              src="/images/headed2/new/hub/H2-Arrow.svg"
              alt={t`Right arrow to move to next section`}
              style={{ maxWidth: '75px', marginTop: '150px' }}
            />
          </Link>
        </div>
      </div>
    )
  }
  const educatorAccount = () => {
    return (
      <div>
        <div className="col-xs-2">
          <Link to="/educators/upgrades/basic">
            <img
              src="/images/headed2/new/hub/H2-Arrow.svg"
              alt={t`Right arrow to move to previous section`}
              style={{
                transform: 'rotate(180deg)',
                maxWidth: '75px',
                marginTop: '150px'
              }}
            />
          </Link>
        </div>
        <div className="col-xs-8">
          <div className="h2account h2account-educator">
            <div className="graphic-top"></div>
            <div className="content">
              <h3 className="text-center section-heading">
                Headed2 Free Educator Account
              </h3>
              <hr />
              <h4 className="text-center">{t`Price: Free`}</h4>
              <div className="description">
                {t`Idea for educators who need more from their Headed2 Account, so
                                they can use it with their students in the classroom.`}
              </div>
              <Link
                to="/requestmanagement"
                className="btn btn-success btn-full"
                style={{ marginBottom: '15px' }}>
                <span>{t`Create Account`}</span>
              </Link>
              <h4>{t`Everything in a Headed2 Account, plus:`}</h4>
              <ul className="free-educator-account-list">
                <li className="free-educator-manage">{t`Manage up to ${dynamicValues.defaultManageeLimit} students`}</li>
                <li className="free-educator-lesson">{t`Build and assign basic lesson plans`}</li>
                <li className="free-educator-messages">{t`Send messages`}</li>
                <li className="free-educator-reports">{t`Run basic reports to monitor student progress`}</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xs-2">
          <Link to="/educators/upgrades/premium">
            <img
              src="/images/headed2/new/hub/H2-Arrow.svg"
              alt={t`Right arrow to move to next section`}
              style={{ maxWidth: '75px', marginTop: '150px' }}
            />
          </Link>
        </div>
      </div>
    )
  }
  const premiumAccount = () => {
    return (
      <div>
        <div className="col-xs-2">
          <Link to="/educators/upgrades/free">
            <img
              src="/images/headed2/new/hub/H2-Arrow.svg"
              alt={t`Right arrow to move to previous section`}
              style={{
                transform: 'rotate(180deg)',
                maxWidth: '75px',
                marginTop: '150px'
              }}
            />
          </Link>
        </div>
        <div className="col-xs-8">
          <div className="h2account h2account-premium">
            <div className="graphic-top"></div>
            <div className="content">
              <h3 className="text-center section-heading">{t`Headed2 Premium Educator Account`}</h3>
              <hr />
              <h4 className="text-center">{t`Price: $89`} *</h4>
              <div className="description">
                {t`Perfect for educators who need even more functionality than the
                                Headed2 Educator Account offers.`}
              </div>
              <a
                className="btn btn-success btn-full"
                href={`${dynamicValues.subscriptionPage}/quote?feature=pea`}
                style={{ marginBottom: '15px' }}>
                <span>{t`Get a Quote`}</span>
              </a>
              <h4>{t`Everything in a Headed2 Educator Account, plus:`}</h4>
              <ul className="prem-educator-account-list">
                <li className="prem-educator-manage check">{t`Manage up to 175 students`}</li>
                <li className="prem-educator-lesson check">{t`Access to pre-loaded lesson plans`}</li>
                <li className="prem-educator-files check">{t`Unlimited file storage and reporting`}</li>
                <li className="prem-educator-enhancedlesson check">
                  {t`Enhanced lesson plans, allowing for
                                    videos, attachments, and surveys`}
                </li>
                <li className="prem-educator-reports check">
                  {t`Run enhanced reports including file tagging
                                    reports and career cluster analysis`}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xs-2"></div>
      </div>
    )
  }
  const chooseContent = () => {
    switch (selectedItem) {
      case 'free':
        return educatorAccount()
      case 'premium':
        return premiumAccount()
      default:
        return basicAccount()
    }
  }

  return (
    <div>
      {chooseContent()}
      <br className="clear" />
    </div>
  )
}

export default UpgradeOptions
